/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to upload a check image or PDF for a transaction
 * @export
 * @interface UploadCheckFileRequest
 */
export interface UploadCheckFileRequest {
    /**
     * Original filename
     * @type {string}
     * @memberof UploadCheckFileRequest
     */
    filename: string;
    /**
     * MIME type (image/jpeg, image/png, application/pdf, etc.)
     * @type {string}
     * @memberof UploadCheckFileRequest
     */
    mimeType: string;
    /**
     * Base64-encoded file content
     * @type {string}
     * @memberof UploadCheckFileRequest
     */
    fileContent: string;
}

/**
 * Check if a given object implements the UploadCheckFileRequest interface.
 */
export function instanceOfUploadCheckFileRequest(value: object): value is UploadCheckFileRequest {
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('fileContent' in value) || value['fileContent'] === undefined) return false;
    return true;
}

export function UploadCheckFileRequestFromJSON(json: any): UploadCheckFileRequest {
    return UploadCheckFileRequestFromJSONTyped(json, false);
}

export function UploadCheckFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadCheckFileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'fileContent': json['fileContent'],
    };
}

export function UploadCheckFileRequestToJSON(json: any): UploadCheckFileRequest {
    return UploadCheckFileRequestToJSONTyped(json, false);
}

export function UploadCheckFileRequestToJSONTyped(value?: UploadCheckFileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'fileContent': value['fileContent'],
    };
}

